var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function({ invalid, validate }){return [_vm._t("default",null,null,{ invalid }),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit(validate, $event)}}},[_vm._t("submit",null,{"invalid":invalid})],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }